/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MeResponse,
  GenericErrorResponse,
} from './responses';


import { HttpClient, RequestParams } from './httpClient';

export class Me<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags App
   * @name initialize
   * @request GET:/me
   * @response `200` `MeResponse` Success
   */
  whoAmI = (params: RequestParams = {}) =>
    this.request<MeResponse, GenericErrorResponse>({
      path: '/me',
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });
}
